import EventBus from '@/utilities/eventBus';

export default {
  data() {
    return {
      parentPageTitleTooltip: false,
      itemTitleTitleTooltip: false,
      projectTitleTitleTooltip: false,
      checkTitleOverflowTimeout: null,
    };
  },

  mounted() {
    this.checkTitleOverflow();
    EventBus.$on('checkBreadcrumbsTitleOverflow', this.checkTitleOverflow);
  },

  methods: {
    checkTitleOverflow() {
      this.checkTitleOverflowTimeout = setTimeout(() => {
        const parentPageEl = this.$refs.pageImmediateParent;
        const itemTitleEl = this.$refs.itemTitle;
        const projectTitleEl = this.$refs.projectTitle;

        if (parentPageEl) {
          this.parentPageTitleTooltip = parentPageEl.scrollWidth > parentPageEl.clientWidth;
        }
        if (itemTitleEl) {
          this.itemTitleTitleTooltip = itemTitleEl.scrollWidth > itemTitleEl.clientWidth;
        }
        if (projectTitleEl) {
          this.projectTitleTitleTooltip = projectTitleEl.scrollWidth > projectTitleEl.clientWidth;
        }
      }, 300);
    },
  },

  unmounted() {
    EventBus.$off('checkBreadcrumbsTitleOverflow', this.checkTitleOverflow);
  },
};
